import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from 'src/components/Octopath/layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Battle = makeShortcode("Battle");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};

const MDXLayout = ({
  children
}) => <Layout>{children}</Layout>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Temenos Single Story" mdxType="SEO" />
    <p>{`These notes are pretty rough, I recommend using `}<a parentName="p" {...{
        "href": "https://docs.google.com/spreadsheets/d/1e2Yp9Tka3wNgwvYY6atafllFEfi60zMziHxKjf-Ei3Y/edit#gid=284811223"
      }}>{`Xazu's Notes`}</a>{` if you want something more detailed. I don't think the routes match up exactly but should be fairly close.`}</p>
    <h2 {...{
      "id": "route"
    }}>{`Route`}</h2>
    <p>{`Start Temenos`}</p>
    <p>{`Pick `}<strong parentName="p">{`Shadow S`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Coerce Vados, Holy Light x2`}</p>
    <p>{`Pick `}<strong parentName="p">{`Light S`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Run from Skeletons.`}</p>
    <p>{`For safety, can heal if you got hit more than T1 hit from Vados. You will want to use a Plum, and replace Temenos's heal turn with Heal Wounds instead of Grape.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "felvarg-3600hp-5s-swordicelight"
      }}>{`Felvarg 3600HP 5S (Sword,Ice,Light)`}</h4>
      <h5 {...{
        "id": "turn-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Holy Light`}</li>
        <li parentName="ul">{`Crick: Sacred Slash`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Holy Light`}</li>
        <li parentName="ul">{`Crick: Cover / Grape`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Defend`}</li>
        <li parentName="ul">{`Crick: Sacred Slash x4`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Holy Light`}</li>
        <li parentName="ul">{`Crick: Shadow S`}</li>
      </ul>
      <h5 {...{
        "id": "turn-5"
      }}>{`Turn 5`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Holy Light x4`}</li>
        <li parentName="ul">{`Crick: Cover x2`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`One of the next 3 Temenos turns should be a Grape or Heal Wounds. If no need can just attack. Notes will do Grape`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-6"
      }}>{`Turn 6`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Holy Light`}</li>
        <li parentName="ul">{`Crick: Sacred Slash`}</li>
      </ul>
      <h5 {...{
        "id": "turn-7"
      }}>{`Turn 7`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Grape`}</li>
        <li parentName="ul">{`Crick: Attack`}</li>
      </ul>
      <h5 {...{
        "id": "turn-8"
      }}>{`Turn 8`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Holy Light`}</li>
        <li parentName="ul">{`Crick: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-9"
      }}>{`Turn 9`}</h5>
      <ul>
        <li parentName="ul">{`Crick: Attack x4`}</li>
        <li parentName="ul">{`Temenos: Holy Light x4`}</li>
      </ul>
      <h5 {...{
        "id": "turn-10"
      }}>{`Turn 10`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Holy Light x3`}</li>
        <li parentName="ul">{`Crick: Light S`}</li>
      </ul>
    </Battle>
    <p>{`Pick `}<strong parentName="p">{`$600`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Get `}<strong parentName="p">{`Osvald`}</strong>{`.`}</p>
    <p>{`Tag `}<strong parentName="p">{`Abandoned Village`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Tag `}<strong parentName="p">{`New Delsta Anchorage`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Tag `}<strong parentName="p">{`New Delsta`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`New Delsta: Anchorage`}</strong>{`. Take boats to `}<strong parentName="p">{`Canalbrine`}</strong>{`.`}</p>
    <h3 {...{
      "id": "canalbrine"
    }}>{`Canalbrine`}</h3>
    <p>{`Start Temenos Ch.2`}<br parentName="p"></br>{`
`}{`Talk to NPCs in Square.`}<br parentName="p"></br>{`
`}{`Get `}<strong parentName="p">{`Castti`}</strong>{`.`}</p>
    <p>{`Inquire NPC in Item Shop for `}<strong parentName="p">{`Slumber Sage`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Buy Lilies?`}</p>
    </blockquote>
    <p>{`Go to house, do Sherlock stuff. TP `}<strong parentName="p">{`New Delsta`}</strong>{`.`}</p>
    <h3 {...{
      "id": "new-delsta"
    }}>{`New Delsta`}</h3>
    <p>{`Switch to Night, start `}<strong parentName="p">{`Throne`}</strong>{` recruitment.`}</p>
    <Battle mdxType="Battle">
      <ul>
        <li parentName="ul">{`Temenos: Holy Light x2 / Attack x2 if before Osvald top one`}</li>
        <li parentName="ul">{`Osvald: Icewind x2`}</li>
        <li parentName="ul">{`Castti: Icicle x2 / Attack x2 if after Osvald Bottom one`}</li>
      </ul>
    </Battle>
    <p>{`Steal `}<strong parentName="p">{`Ice S, Wind S, Light S`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`Antique Coin`}</strong>{`. Steal `}<strong parentName="p">{`Pom S`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Soothe `}<strong parentName="p">{`Aggravated Woman`}</strong>{` to complete `}<strong parentName="p">{`Utterly Exhausted!`}</strong>{` quest.`}<br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`Rare Cog`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Abandoned Village`}</strong>{`.`}</p>
    <h3 {...{
      "id": "abandoned-village"
    }}>{`Abandoned Village`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Herb of Serenity`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you get Concoct Materials at Black Market, buy 1 Bluserbloom 2 Lily of the Light`}</p>
    </blockquote>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "sell"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Antique Coin`}</li>
        <li parentName="ul">{`Gold Ring`}</li>
        <li parentName="ul">{`Dragon Scarf`}</li>
      </ul>
      <h5 {...{
        "id": "buy"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`2 Fire M`}</li>
        <li parentName="ul">{`6 Light M`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Beasting Bay: Anchorage`}</strong>{`.`}</p>
    <h3 {...{
      "id": "beasting-bay-anchorage"
    }}>{`Beasting Bay: Anchorage`}</h3>
    <p>{`Will probably want to kill 2 battles here.`}</p>
    <ul>
      <li parentName="ul">{`Fierce Fly, Motley Slug: Ice S + Light S. Or break Fly with Sword & Slug with Sword/Axe.`}</li>
      <li parentName="ul">{`Fierce Fly, Island Froggen II: Same as above, except break with Dagger/Axe for Froggen.`}</li>
      <li parentName="ul">{`Island Froggen I x2, Island Froggen II: Ice S + Dagger Axe on Froggen II. Or break 1st and any S.`}</li>
      <li parentName="ul">{`Island Froggen II x2 : Ice S + 31 damage`}</li>
      <li parentName="ul">{`Lloris x2, Long-Eared Lloris: Break LLoris with Sword/Axe/Staff, S Stone + 140 damage`}</li>
      <li parentName="ul">{`Island Froggen I x2, Motley Slug: Break Slug with Sword/Axe/Staff and S Stone.`}</li>
    </ul>
    <p>{`Tropu'hopu: Kill with Light M`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "learn-skills"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: +Mystical Staff`}</li>
        <li parentName="ul">{`Osvald: +Lightning Bolt +Analyze`}</li>
        <li parentName="ul">{`Castti: +Sweeping Cleave`}</li>
        <li parentName="ul">{`Throne: +Surprise Attack`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: +Evasive Maneuvers`}</li>
      </ul>
    </Menu>
    <p>{`Nameless Village Traverse: Run to save, S&Q, walk to `}<strong parentName="p">{`Nameless Village`}</strong>{`.`}</p>
    <h3 {...{
      "id": "nameless-village"
    }}>{`Nameless Village`}</h3>
    <p>{`TP `}<strong parentName="p">{`New Delsta: Anchorage`}</strong>{`. Take boat to `}<strong parentName="p">{`Crackridge Harbor Anchorage`}</strong>{`.`}</p>
    <h3 {...{
      "id": "crackridge-harbor-anchorage"
    }}>{`Crackridge Harbor Anchorage`}</h3>
    <p>{`Head towards `}<strong parentName="p">{`Crackridge`}</strong>{`.`}</p>
    <h4 {...{
      "id": "southern-crackridge-wilds"
    }}>{`Southern Crackridge Wilds`}</h4>
    <p>{`Switch to night near top of steps.`}<br parentName="p"></br>{`
`}{`Kill battle with 2 Light M or break Armor Eater + 1 Light M.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$6400`}</strong>{`.`}</p>
    <h4 {...{
      "id": "western-crackridge-wilds"
    }}>{`Western Crackridge Wilds`}</h4>
    <p>{`Switch to night around 1st intersection. Kill battle with 2 Light M or break Armor Eater + 1 Light M.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$8400`}</strong>{`. Pick `}<strong parentName="p">{`Thunder M`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Mug Merchant to reset steps. Get `}<strong parentName="p">{`Merchant License`}</strong>{`. Go to `}<strong parentName="p">{`Crackridge`}</strong>{`.`}</p>
    <h3 {...{
      "id": "crackridge"
    }}>{`Crackridge`}</h3>
    <p>{`TP `}<strong parentName="p">{`Flamechurch`}</strong>{`. Head to `}<strong parentName="p">{`Stormhail`}</strong>{`.`}</p>
    <p>{`Kill Bolderfall and Montwise battles with Fire Ms.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Merchant, +Sidestep +Hired Help`}</li>
      </ul>
    </Menu>
        
Soothe Guard.
    <h4 {...{
      "id": "northern-montwise-pass"
    }}>{`Northern Montwise Pass`}</h4>
    <p>{`Fight at Night. HHG x2, Big Monkey Thunder M as well (range, needs HHG crits).`}</p>
    <h4 {...{
      "id": "southern-stormhail-snows"
    }}>{`Southern Stormhail Snows`}</h4>
    <p>{`Switch to night at stairs. Kill battle with HHG x2 (Reptalios throw a M Stone too).`}</p>
    <blockquote>
      <h3 parentName="blockquote" {...{
        "id": "cait--puff-differences"
      }}>{`Cait & Puff Differences`}</h3>
      <p parentName="blockquote">{`If you kill any, you now break Wandering Wood battle instead of killing`}<br parentName="p"></br>{`
`}{`Cait: Only one that still does 2x Stormhail battle.`}<br parentName="p"></br>{`
`}{`Puff: Skip Stormhail stuff.`}<br parentName="p"></br>{`
`}{`Cultured Cait: Skip Stormhail stuff.`}<br parentName="p"></br>{`
`}{`Queen Puff: Skip Stormhail stuff.`}</p>
      <p parentName="blockquote">{`Caits can either tank/skip Cubaryi Collect with $30000 fight, or skip Jade Staff + Knight's Armor`}<br parentName="p"></br>{`
`}{`Regular Puff should get a small item, maybe Traveler's Bow`}</p>
    </blockquote>
    <p>{`Switch back to day, pick `}<strong parentName="p">{`$15000`}</strong>{`. Go to `}<strong parentName="p">{`Ice L`}</strong>{`, switch to night bit before reaching it. Pick `}<strong parentName="p">{`Ice L`}</strong>{`. Kill 2nd battle the same way. Switch back to day.`}</p>
    <p>{`If you got the battle after going down the last ladder, can run rest. Otherwise walk a bit.`}<br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`Pom M`}</strong>{`.`}</p>
    <h3 {...{
      "id": "stormhail"
    }}>{`Stormhail`}</h3>
    <p>{`Go to Weapon Shop, Mug guy for weapons (M Stone).`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "items"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Ogre's Bane > Throne`}</li>
        <li parentName="ul">{`Imperial Axe > Castti`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-1"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Throne: +Collect`}</li>
        <li parentName="ul">{`Castti: Merchant, +3 Skills`}</li>
        <li parentName="ul">{`Temenos: Merchant, +3 Skills`}</li>
        <li parentName="ul">{`Osvald: Merchant, +3 Skills`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-1"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: +`}{`[1]`}{`Grow on Trees +`}{`[2]`}{`Boost-Start`}</li>
        <li parentName="ul">{`Throne: +`}{`[2]`}{`Boost-Start`}</li>
        <li parentName="ul">{`Castti: +`}{`[2]`}{`Grow on Trees +`}{`[3]`}{`Boost-Start`}</li>
        <li parentName="ul">{`Osvald: +`}{`[3]`}{`Boost-Start`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Canalbrine`}</strong>{`.`}</p>
    <h3 {...{
      "id": "canalbrine-1"
    }}>{`Canalbrine`}</h3>
    <p>{`Head towards Tavern.`}<br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`Forget-me-do`}</strong>{`, optionally Wind M.`}<br parentName="p"></br>{`
`}{`If no drop, Steal `}<strong parentName="p">{`Sticky Flower`}</strong>{` and/or `}<strong parentName="p">{`Cleansing Leaf`}</strong>{`.`}</p>
    <p>{`Go to Tavern, Coerce Vados.`}</p>
    <Battle mdxType="Battle">
      <ul>
        <li parentName="ul">{`1: Mystical Staff`}</li>
        <li parentName="ul">{`2: Attack x4 if not Blinded / Attack`}</li>
        <li parentName="ul">{`3: Attack x4 / Attack`}</li>
      </ul>
    </Battle>
    <p>{`Go to Sacred Guard Ship.`}</p>
    <h3 {...{
      "id": "sacred-guard-ship"
    }}>{`Sacred Guard Ship`}</h3>
    <p>{`Pick `}<strong parentName="p">{`$5600`}</strong>{`.`}<br parentName="p"></br>{`
`}{`If no Caits/Puffs, can kill battle here. In that case, run whole screen. Else, walk after entering door. Killing the battle isn't recommended as it only gives about 30JP. Kill is Sweeping Cleave x3 (Day)`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "vados-the-architect-14000hp-6s-speardaggericelight"
      }}>{`Vados the Architect 14000HP 6S (Spear,Dagger,Ice,Light)`}</h4>
      <h5 {...{
        "id": "turn-1-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: `}{`[LP]`}{` Attack x3 / Holy Light`}</li>
        <li parentName="ul">{`Osvald: Spear x3`}</li>
        <li parentName="ul">{`Castti: Defend / Lily x2 / Icicle`}</li>
        <li parentName="ul">{`Throne: Defend / Attack`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-1"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Surprise Attack x4`}</li>
        <li parentName="ul">{`Castti: Sweeping Cleave x4`}</li>
        <li parentName="ul">{`If needed, M Stone`}</li>
      </ul>
    </Battle>
    <blockquote>
      <p parentName="blockquote">{`These can be done in either order. I think Stormhail 1st is generally better since it gives you a better idea of what money & JP you need. The primary reason to go Crackridge 1st is if you need to Steal the Shadow M in Stormhail and aren't LVL16 yet. Notes will assume Stormhail 1st.`}</p>
    </blockquote>
    <p>{`TP `}<strong parentName="p">{`Stormhail`}</strong>{`.`}</p>
    <h3 {...{
      "id": "stormhail-1"
    }}>{`Stormhail`}</h3>
    <p>{`If no Throne LP, stay at inn.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Pick Knight's Armor`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-2"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Merchant`}</li>
      </ul>
    </Menu>
    <blockquote>
      <p parentName="blockquote">{`If no L Stone, can pick `}<strong parentName="p">{`Light L`}</strong>{` after Guide sequence with Crick. Costs 15s.`}</p>
    </blockquote>
    <h4 {...{
      "id": "forbidden-shrine"
    }}>{`Forbidden Shrine`}</h4>
    <p>{`Kill battle at night with HHG x3. Walk rest of screen.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$15000`}</strong>{`. Enter boss fight `}<strong parentName="p">{`DURING DAY`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If your JP is bad, you can try to kill 2 battles here and do HHB Cubaryi. Generally not recommended as Ambush & death rate is high. Does have the benefit of letting you run the screen though.`}</p>
    </blockquote>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "deputy-cubaryi-53500hp-5s-spearaxestaff"
      }}>{`Deputy Cubaryi 53500HP 5S (Spear,Axe,Staff)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Someone will die here. If it's Throne, you can't Collect and will need backup money + good turn order`}<br parentName="p"></br>{`
`}{`No Cait/Puff route assumes you do HHV + HHG. Can also do HHB + HHB, will likely need to fill damage with Stones.`}</p>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`Prioritize Castti not being the one to Defend`}<br parentName="p"></br>{`
`}{`HHV strat: Need extra damage with 2 crits or less (31%). Sweeping Cleave covers with 2/4 crits (93%). Assumes HHV all hit 9999`}<br parentName="p"></br>{`
`}{`HHB strat: Need 0 M with 7 Crits (30%), 1M with 5 Crits (85%), 2M with 4 Crits (95%), 2M + Sweeping Cleave with 3 Crits (99.3%)`}</p>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`Notes assume Osvald dies for simplicity`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-2"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Spear`}</li>
        <li parentName="ul">{`Castti: Healing Touch`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Attack x4`}</li>
        <li parentName="ul">{`Throne: HHV x4`}</li>
        <li parentName="ul">{`Castti: Pom S Throne`}</li>
        <li parentName="ul">{`Osvald: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-1"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Pom L Throne`}</li>
        <li parentName="ul">{`Throne: `}{`[LP]`}{`Collect x3 + HHG x4`}</li>
        <li parentName="ul">{`Castti: Sweeping Cleave/M Stone if necessary`}</li>
        <li parentName="ul">{`Temenos: M Stone if necessary`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Crackridge`}</strong>{`.`}</p>
    <h3 {...{
      "id": "crackridge-1"
    }}>{`Crackridge`}</h3>
    <p>{`Go to Inn. Guide Reiza.`}</p>
    <h4 {...{
      "id": "abandoned-road"
    }}>{`Abandoned Road`}</h4>
    <p>{`Switch to Night around steps. Kill battle, `}<strong parentName="p">{`WATCH JP AFTER`}</strong></p>
    <blockquote>
      <p parentName="blockquote">{`After Abandoned Road, lowest JP character needs`}<br parentName="p"></br>{`
`}{`884 With Wandering Wood Battle, 873 if you get 1T bonus.`}<br parentName="p"></br>{`
`}{`1000 Without Wandering Wood`}<br parentName="p"></br>{`
`}{`If short, kill battle in Fellsun Ruins`}</p>
    </blockquote>
    <p>{`Pick `}<strong parentName="p">{`$9200`}</strong>{`.`}</p>
    <h4 {...{
      "id": "fellsun-ruins"
    }}>{`Fellsun Ruins`}</h4>
    <p>{`Pick `}<strong parentName="p">{`Pom L`}</strong>{`. Pick `}<strong parentName="p">{`Jade Staff`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Nameless Village`}</strong>{`.`}</p>
    <h3 {...{
      "id": "nameless-village-1"
    }}>{`Nameless Village`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "items-1"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Unequip Imperial Axe`}</li>
        <li parentName="ul">{`Unequip Ogre's Bane`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Teach Hang Tough here if you can.`}</p>
      </blockquote>
    </Menu>
    <p>{`Go to `}<strong parentName="p">{`Item Shop`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`Need $60000 if not taking Wandering Wood battle, $65416 if you are, $65258 if you get Untouched bonus`}</p>
      </blockquote>
      <h5 {...{
        "id": "sell-1"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Ogre's Bane`}</li>
        <li parentName="ul">{`Imperial Axe`}</li>
        <li parentName="ul">{`Thunderstorm Amulet`}</li>
        <li parentName="ul">{`Knight's Armor`}</li>
        <li parentName="ul">{`Jade Staff`}</li>
        <li parentName="ul">{`Refreshing Jam`}</li>
      </ul>
    </Menu>
    <p>{`Guide `}<strong parentName="p">{`Shirlutto`}</strong>{`.`}</p>
    <h3 {...{
      "id": "wandering-wood"
    }}>{`Wandering Wood`}</h3>
    <p>{`Switch to night before battle. Break with Attacks/Spears if fleeing, kill with HHG x3 if taking.`}<br parentName="p"></br>{`
`}{`Walk rest of screen.`}</p>
    <h3 {...{
      "id": "rifted-rock"
    }}>{`Rifted Rock`}</h3>
    <p>{`Walk screen, reset steps with Travel Banter.`}</p>
    <Battle mdxType="Battle">
      <blockquote>
        <p parentName="blockquote">{`Extra damage requirements (No Sticky/Sticky)`}<br parentName="p"></br>{`
`}{`0 Crit: 9600`}<br parentName="p"></br>{`
`}{`1 Crit: 7800 (77.4%/99.9%) - L + M Stone`}<br parentName="p"></br>{`
`}{`2 Crit: 6000 (40.5%/99.3%) - L + M Stone`}<br parentName="p"></br>{`
`}{`3 Crit: 4200 (14.1%/95.8%) - 2 M Stone or L Stone`}<br parentName="p"></br>{`
`}{`4 Crit: 2400 (3.27%/84.6%) - M Stone usually`}<br parentName="p"></br>{`
`}{`5 Crit: 600  (0.05%/62.4%) - M Stone or high rolls`}<br parentName="p"></br>{`
`}{`6-7: 0 (0.0005%/34.3%) - No extra damage needed`}</p>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`There are various ways to win this fight. This will be an example script that assumes you have a Blusterbloom. I will go into various Kaldena variations and explanations in the addendum.`}</p>
      </blockquote>
      <h4 {...{
        "id": "kaldena-100000hp-8s-spearstafficewind"
      }}>{`Kaldena 100000HP 8S (Spear,Staff,Ice,Wind)`}</h4>
      <h5 {...{
        "id": "turn-1-3"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Defend`}</li>
        <li parentName="ul">{`Osvald: HGB`}</li>
        <li parentName="ul">{`Castti: Defend`}</li>
        <li parentName="ul">{`Throne: Pom M Self`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-3"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Castti: `}{`[LP]`}{`Concoct Blusterbloom x4 + Sticky Flower`}</li>
        <li parentName="ul">{`Temenos: Attack x4`}</li>
        <li parentName="ul">{`Throne: `}{`[LP]`}{`HHB x4, HHB x3`}</li>
        <li parentName="ul">{`Osvald: Pom L Throne / M Stone / Defend and Pom if Throne is 1st T3`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-2"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Throne: HHV x4`}</li>
        <li parentName="ul">{`Castti: Concoct Forget-me-do + Blusterbloom`}</li>
        <li parentName="ul">{`Others: Throw Stones`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "addendum"
    }}>{`Addendum`}</h3>
    <h4 {...{
      "id": "kaldena"
    }}>{`Kaldena`}</h4>
    <p>{`There are a lot of ways to play this fight, based on turn orders and what she does. I will try to list out your options here, but I recommend reading this and just practicing the fight yourself. Kaldena appears scary, but the success rate is actually fairly high if played correctly.`}</p>
    <p>{`First off, Kaldena will always do 2 attacks T1, an AoE dark that can blind, and a single target physical that takes 1BP off whoever it hits. Thanks to the blind from Temenos' Talent, the single target only has a 50% chance to hit. If she does it first and misses, you don't need to heal. Another thing to note is that thanks to Throne's Talent, Kaldena's 2nd action will always be last T1.`}</p>
    <h5 {...{
      "id": "sticky-flower"
    }}>{`Sticky Flower`}</h5>
    <p>{`Sticky Flower is INCREDIBLY useful in this fight. It does 3 things:`}</p>
    <ol>
      <li parentName="ol">{`It reduces Kaldena's speed, increasing the crit rate of Hired Help from 17% to 61.5%. This reduces the amount of stones you need on average greatly, and let's you kill without a L Stone most of the time.`}</li>
      <li parentName="ol">{`It reduces her Evasion. This increases your parties accuracy to 100%, 50% if not blinded. Even if not blinded, Osvald and Temenos can still miss normally.`}</li>
      <li parentName="ol">{`It moves her turns back T2. For every Sticky Flower used, it moves her turns back 1 slot T2. So if order is Kaldena > Kaldena > Osvald > Throne, if you Sticky Flower x2 you can skip Osvald Defending, as he'll end up 1st T2.`}</li>
    </ol>
    <p>{`You generally want to have Sticky Flower active T1&T2, and ideally use HHB x7 T2 for the increased crit rate. You'll ideally combo it with Blusterblooms, but if you don't have any Sticky x3 + Forget-me-do is a viable opening. Castti isn't guaranteed to get hit before her turn T1, it's very nice if you can go into this fight with her LP filled.`}</p>
    <h5 {...{
      "id": "diffusing--pom-leaf"
    }}>{`Diffusing + Pom Leaf`}</h5>
    <p>{`If you don't have a Blusterbloom, you can opt into Stealing a Pom Leaf in Nameless Village inn and buying a Diffusing at the General Store. You can also Steal a Cleansing Leaf in Canalbrine along with the Sticky Flower in Canalbrine, or buy both a Cleansing Leaf and a Grape Leaf in Canalbrine General Store. The issue with buying them early is that they're often not needed if you get a Blusterbloom. If you do this strat, you need to save 3k to afford the Diffusing Serum. I recommend doing HHB Cubaryi and skipping the Jade Staff.`}</p>
    <p>{`Ideally you have LP for the fight, and if Castti is before Kaldena blind Diffusing + Pom Leaf x3 is pretty good. It really shines if she's after the blind attack, since you can do Diffusing + Pom Leaf + Pom Leaf/Grape Leaf + Cleansing Leaf to remove the Blind and give people BP.`}</p>
    <h3 {...{
      "id": "changelog"
    }}>{`Changelog`}</h3>
    <h4 {...{
      "id": "31324"
    }}>{`3/13/24`}</h4>
    <ul>
      <li parentName="ul">{`Initial upload`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      